import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {apiIdToIconName} from 'util/APIUtil';

import RequestV2SubmissionChipPopoverContent from './RequestV2SubmissionChipPopoverContents';

export default function RequestV2SubmissionChip(
  props: SharedSmartChipProps<SmartChipType.REQUEST_V2_SUBMISSION>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: requestV2Submission,
    handleClickLink,
    isInaccessible,
    itemUrl: requestV2SubmissionUrl,
  } = useSmartChipQuery<SmartChipType.REQUEST_V2_SUBMISSION>({
    id,
    onClick,
    getUrlFn: (requestV2Submission) => requestV2Submission.editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={requestV2Submission != null ? apiIdToIconName(requestV2Submission.id) : null}
      isInaccessible={isInaccessible}
      item={requestV2Submission}
      onClick={handleClickLink}
      url={requestV2SubmissionUrl}
      popoverContentOverride={id != null ? <RequestV2SubmissionChipPopoverContent id={id} /> : null}
    />
  );
}
